import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import './DealDetailPage.css';
import axios from 'axios';
import UserService from '../services/UserService';

const SUBJECTS = ["Ask about a deal?", "Give feedback on our site", "Other"];

const emptyForm = {
  email: "",
  name: "",
  subject: SUBJECTS[0],
  message: "",
  post: "contactus"
};

function ContactUs() {
  const [contactdetail, setcontactdetail] = useState(emptyForm);
  const [status, setStatus] = useState("idle") // idle | sending | done | error

  const contactdetails = (e) => {
    e.preventDefault();
    if (contactdetail.email.trim() === '' || contactdetail.message.trim() === '') {
      return
    }
    setStatus("sending")
    axios.post(UserService.getURl() + "/contactus/add", contactdetail, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'multipart/form-data'
      }
    }).then(response => {
      if (response.data != null) {
        setStatus("done")
        setcontactdetail(emptyForm)
      } else {
        setStatus("error")
      }
    }).catch(error => {
      console.error("Contact form submission failed", error)
      setStatus("error")
    })
  }

  const handlechange = (e) => {
    setcontactdetail({ ...contactdetail, [e.target.name]: e.target.value })
  }

  return (
    <div className="detail-page">
      <div className="detail-layout page-narrow">
        <main>
          <nav className="detail-breadcrumb" aria-label="Breadcrumb">
            <Link to="/">Home</Link>
            <span>›</span>
            <span>Contact Us</span>
          </nav>

          <section className="page-card">
            {status === "done" ? (
              <div className="page-success">
                <h2>Thank you for contacting us!</h2>
                <p>We will get back to you shortly.</p>
                <p><Link to="/">← Back to all deals</Link></p>
              </div>
            ) : (
              <>
                <h1>Contact Us</h1>
                <p className="page-intro">We would like to hear from you. Ask about a deal, share feedback, or just say hi.</p>

                <form className="page-form" onSubmit={contactdetails}>
                  <label>
                    Email
                    <input name="email" type="email" placeholder="you@example.com" required
                      value={contactdetail.email} onChange={handlechange} />
                  </label>
                  <label>
                    Your name
                    <input name="name" type="text" placeholder="Your name"
                      value={contactdetail.name} onChange={handlechange} />
                  </label>
                  <label>
                    Subject
                    <select name="subject" value={contactdetail.subject} onChange={handlechange}>
                      {SUBJECTS.map((s) => <option key={s} value={s}>{s}</option>)}
                    </select>
                  </label>
                  <label>
                    Message
                    <textarea name="message" placeholder="Type your message..." required
                      value={contactdetail.message} onChange={handlechange} />
                  </label>

                  {status === "error" && (
                    <p className="page-error">Sorry, your message could not be sent. Please try again or email us.</p>
                  )}

                  <button type="submit" disabled={status === "sending"}>
                    {status === "sending" ? "Sending..." : "Send Message"}
                  </button>
                </form>

                <p className="page-or">
                  Prefer email? Write to us at <a href="mailto:dinodealz18@gmail.com">dinodealz18@gmail.com</a>
                </p>
              </>
            )}
          </section>
        </main>
      </div>
    </div>
  )
}

export default ContactUs
